module.exports = __webpack_public_path__ + "media/images/emoticons/birthday-28b26cefba3d4e4914e70c5ba6ca5359.gif";